module.exports = __webpack_public_path__ + "static/media/cert3.1e11de4c.png";